/**
 * @generated SignedSource<<be4840584ba8ba8af3c655617d2b0294>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUProductCreateQuery$variables = Record<PropertyKey, never>;
export type PLUProductCreateQuery$data = {
  readonly pluCategories: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
    readonly title: string;
  }>;
};
export type PLUProductCreateQuery = {
  response: PLUProductCreateQuery$data;
  variables: PLUProductCreateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PLUCategory",
    "kind": "LinkedField",
    "name": "pluCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUProductCreateQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PLUProductCreateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9056f9aa7d69b1daefb8e1d898dccf27",
    "id": null,
    "metadata": {},
    "name": "PLUProductCreateQuery",
    "operationKind": "query",
    "text": "query PLUProductCreateQuery {\n  pluCategories {\n    id\n    color\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb53f61474866a65f1aca0ba49cf358f";

export default node;
